import {
  AppBar,  Avatar,  Badge,  Box,  Divider,  IconButton,  InputBase,  ListItemIcon,  Menu,
  MenuItem,  Toolbar,  Typography} from "@mui/material";
import React, { useState } from "react";
import {  Email,  Logout,  Notifications,  Person,
  Search,  Settings,  Storefront} from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { Link } from "react-router-dom";
import { getLocalValue, LoacalVariables } from "../../commonFunctions/CommonFunctions";

interface NavbarProps {
  collapse: boolean;
  drawerWidth?: number;
  handleCollapse: () => void;
  anchorEl: null | HTMLElement;
  badgeContent?: number;
  position?: "fixed" | "absolute" | "relative" | "static" | "sticky";
  backgroundColor?: string;
  iconColor?: string;
  height?: string;
}

const Navbar2: React.FC<NavbarProps> = ({
  collapse,
  drawerWidth = 240,
  handleCollapse,
  badgeContent = 0,
  backgroundColor = "#ffffff",
  iconColor = "#4a4b77"
}) => {
  const [profileAnchor, setProfileAnchor] = useState<null | HTMLElement>(null);
  const openProfileMenu = (event: React.MouseEvent<HTMLElement>) =>
    setProfileAnchor(event.currentTarget);
  const closeProfileMenu = () => setProfileAnchor(null);

  // State for Notifications Menu
  const [notificationAnchor, setNotificationAnchor] =
    useState<null | HTMLElement>(null);
  const openNotificationMenu = (event: React.MouseEvent<HTMLElement>) =>
    setNotificationAnchor(event.currentTarget);
  const closeNotificationMenu = () => setNotificationAnchor(null);

  // const handleLogout = () => {};
  return (
    <AppBar
      position="fixed"
      sx={{
        width: { sm: `calc(100% - ${!collapse ? drawerWidth : 0}px)` },
        ml: { sm: `${!collapse ? drawerWidth : 0}px` },
        backgroundColor: backgroundColor,
        boxShadow: 0
      }}
    >
      <Toolbar>
      <IconButton
        onClick={handleCollapse}
        sx={{
          position: "fixed",
          top: "16px",
          left: collapse ? "100px" : "250px", // Adjust position based on state
          zIndex: 1400, // Increased z-index to keep sidebar and menus on top
          backgroundColor: "#3D52A0",
          color: "#fff",
          "&:hover": { backgroundColor: "#23255a" }
        }}
      >
        {collapse ? <MenuIcon /> : <MenuOpenIcon />}
      </IconButton>

        <Typography
          variant="h6"
          sx={{
            flexGrow: 1,
            marginLeft: collapse ? "140px" : "50px",
            transition: "margin-left 0.4s ease",
            color: "#b4252b",
            fontWeight: "bold"
          }}
        >
          Hello {getLocalValue(LoacalVariables.Name)}
          <span
            style={{
              color: "gray",
              fontSize: "0.875rem",
              display: "flex",
              fontWeight: "lighter"
            }}
          >
            Here's your overview
          </span>
        </Typography>

        {/* Search Bar */}
        {/* <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            bgcolor: "#f1f1f1",
            p: 1,
            borderRadius: 2
          }}
        >
          <Search sx={{ color: "#555" }} />
          <InputBase placeholder="Search" sx={{ ml: 1, flex: 1 }} />
        </Box> */}

        <Box
          sx={{
            display: "flex",
            flexGrow: 1,
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 3
          }}
        >
          {/* Email */}
          {/* <IconButton sx={{ color: iconColor }}>
            <Badge badgeContent={badgeContent} color="error">
              <Email />
            </Badge>
          </IconButton> */}

          {/* Shop */}
          {/* <IconButton sx={{ color: iconColor }}>
            <Badge badgeContent={badgeContent} color="error">
              <Storefront />
            </Badge>
          </IconButton> */}

          {/* Notifications Dropdown */}
          {/* <IconButton sx={{ color: iconColor }} onClick={openNotificationMenu}>
            <Badge badgeContent={badgeContent} color="error">
              <Notifications />
            </Badge>
          </IconButton> */}

          <Menu
            anchorEl={notificationAnchor}
            open={Boolean(notificationAnchor)}
            onClose={closeNotificationMenu}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            {badgeContent > 0 ? (
              <>
                <MenuItem onClick={closeNotificationMenu}>
                  New Order Received
                </MenuItem>
                <MenuItem onClick={closeNotificationMenu}>
                  Payment Successful
                </MenuItem>
              </>
            ) : (
              <MenuItem>No Notifications</MenuItem>
            )}
          </Menu>

          {/* Settings */}
          {/* <IconButton sx={{ color: iconColor }}>
            <Settings />
          </IconButton> */}

          {/* Profile Button */}
          <IconButton onClick={openProfileMenu}>
            <Avatar />
          </IconButton>

          {/* Custom Dropdown Menu */}
          <Menu
            anchorEl={profileAnchor}
            open={Boolean(profileAnchor)}
            onClose={closeProfileMenu}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{
              sx: {
                width: 180, // Increased width
                borderRadius: 2, // Rounded corners
                boxShadow: 3 // Soft shadow
              }
            }}
          >
            {/* Profile Option */}
            {/* <MenuItem onClick={closeProfileMenu}>
              <ListItemIcon>
                <Person fontSize="small" />
              </ListItemIcon>
              <Typography variant="body2">Profile</Typography>
            </MenuItem> */}

            {/* Divider */}
            <Divider />

            {/* Logout Option */}
            <MenuItem component={Link} to="/logOut">
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              <Typography variant="body2" color="error">
                Logout
              </Typography>
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
      <Divider />
    </AppBar>
  );
};

export default Navbar2;
